"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// These statuses are used in recalculate_batch() trigger function on zunta-management-service
// Please, update trigger function logic, if you update the statuses
var EStatementStatuses;
(function (EStatementStatuses) {
    EStatementStatuses["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    EStatementStatuses["NEEDS_FIX"] = "NEEDS_FIX";
    EStatementStatuses["DO_NOT_BILL"] = "DO_NOT_BILL";
    EStatementStatuses["READY_TO_MAIL"] = "READY_TO_MAIL";
    EStatementStatuses["READY_TO_EMAIL"] = "READY_TO_EMAIL";
    EStatementStatuses["READY_TO_PRINT"] = "READY_TO_PRINT";
    EStatementStatuses["DELIVERED"] = "DELIVERED";
    EStatementStatuses["PROCESSED_FOR_DELIVERY"] = "PROCESSED_FOR_DELIVERY";
    EStatementStatuses["REROUTED"] = "REROUTED";
    EStatementStatuses["RETURNED"] = "RETURNED";
    EStatementStatuses["PENDING"] = "PENDING";
    EStatementStatuses["PRINTED_LOCALLY"] = "PRINTED_LOCALLY";
    EStatementStatuses["IN_PROCESS"] = "IN_PROCESS";
    EStatementStatuses["IN_TRANSIT"] = "IN_TRANSIT";
    EStatementStatuses["IN_LOCALAREA"] = "IN_LOCALAREA";
    EStatementStatuses["EMAILED"] = "EMAILED";
    EStatementStatuses["EMAIL_RETURNED"] = "EMAIL_RETURNED";
    EStatementStatuses["DO_NOT_BILL_NEGATIVE"] = "DO_NOT_BILL_NEGATIVE";
    EStatementStatuses["DO_NOT_BILL_ZERO"] = "DO_NOT_BILL_ZERO";
    EStatementStatuses["DO_NOT_BILL_PERMANENTLY"] = "DO_NOT_BILL_PERMANENTLY";
    EStatementStatuses["DO_NOT_BILL_NOW"] = "DO_NOT_BILL_NOW";
    EStatementStatuses["DO_NOT_BILL_CONTROL"] = "DO_NOT_BILL_CONTROL";
    EStatementStatuses["DO_NOT_BILL_RETURNED"] = "DO_NOT_BILL_RETURNED";
    EStatementStatuses["ALREADY_SENT"] = "ALREADY_SENT";
    EStatementStatuses["DO_NOT_BILL_EMAIL_RETURNED"] = "DO_NOT_BILL_EMAIL_RETURNED";
})(EStatementStatuses = exports.EStatementStatuses || (exports.EStatementStatuses = {}));
var EBilingStatus;
(function (EBilingStatus) {
    EBilingStatus["PAID"] = "PAID";
    EBilingStatus["BILL_OVERDUE"] = "BILL_OVERDUE";
    EBilingStatus["BILLED"] = "BILLED";
    EBilingStatus["ERROR"] = "ERROR";
})(EBilingStatus = exports.EBilingStatus || (exports.EBilingStatus = {}));
var EBatchStatus;
(function (EBatchStatus) {
    EBatchStatus["COMPLETE"] = "COMPLETE";
    EBatchStatus["INCOMPLETE"] = "INCOMPLETE";
    EBatchStatus["RETURNED_MAIL"] = "RETURNED_MAIL";
})(EBatchStatus = exports.EBatchStatus || (exports.EBatchStatus = {}));
var ETransactionEffectiveDateStatus;
(function (ETransactionEffectiveDateStatus) {
    ETransactionEffectiveDateStatus["BILLED"] = "BILLED";
    ETransactionEffectiveDateStatus["DUE"] = "DUE";
    ETransactionEffectiveDateStatus["OVERDUE"] = "OVERDUE";
    ETransactionEffectiveDateStatus["DELINQUENT"] = "DELINQUENT";
    ETransactionEffectiveDateStatus["PAID"] = "PAID";
    ETransactionEffectiveDateStatus["WRITTEN_OFF"] = "WRITTEN_OFF";
    ETransactionEffectiveDateStatus["WRITTEN_OFF_AND_CEASE_COLLECTIONS"] = "WRITTEN_OFF_AND_CEASE_COLLECTIONS";
})(ETransactionEffectiveDateStatus = exports.ETransactionEffectiveDateStatus || (exports.ETransactionEffectiveDateStatus = {}));
var EEmailEventEntityType;
(function (EEmailEventEntityType) {
    EEmailEventEntityType["LETTER"] = "LETTER";
    EEmailEventEntityType["STATEMENT"] = "STATEMENT";
})(EEmailEventEntityType = exports.EEmailEventEntityType || (exports.EEmailEventEntityType = {}));
var EEmailEvent;
(function (EEmailEvent) {
    EEmailEvent["PROCESSED"] = "processed";
    EEmailEvent["DEFERRED"] = "deferred";
    EEmailEvent["DELIVERED"] = "delivered";
    EEmailEvent["OPEN"] = "open";
    EEmailEvent["CLICK"] = "click";
    EEmailEvent["BOUNCE"] = "bounce";
    EEmailEvent["DROPPED"] = "dropped";
    EEmailEvent["SPAMREPORT"] = "spamreport";
    EEmailEvent["UNSUBSCRIBE"] = "unsubscribe";
    EEmailEvent["GROUP_UNSUBSCRIBE"] = "group_unsubscribe";
    EEmailEvent["GROUP_RESUBSCRIBE"] = "group_resubscribe";
})(EEmailEvent = exports.EEmailEvent || (exports.EEmailEvent = {}));
var EBreakdownType;
(function (EBreakdownType) {
    EBreakdownType["PREVIOUS"] = "PREVIOUS";
    EBreakdownType["ADJUSTMENT"] = "ADJUSTMENT";
})(EBreakdownType = exports.EBreakdownType || (exports.EBreakdownType = {}));
var EStatementHistoryEvent;
(function (EStatementHistoryEvent) {
    EStatementHistoryEvent["STATUS_CHANGE"] = "STATUS_CHANGE";
    EStatementHistoryEvent["MAILED_OUT"] = "MAIL_OUT";
    EStatementHistoryEvent["EMAILED"] = "EMAILED";
    EStatementHistoryEvent["PRINTED_LOCALLY"] = "PRINTED_LOCALLY";
    EStatementHistoryEvent["STATEMENT_CREATED"] = "STATEMENT_CREATED";
    EStatementHistoryEvent["STATEMENT_UPDATED"] = "STATEMENT_UPDATED";
})(EStatementHistoryEvent = exports.EStatementHistoryEvent || (exports.EStatementHistoryEvent = {}));
var ELobMailedStatementStatuses;
(function (ELobMailedStatementStatuses) {
    ELobMailedStatementStatuses["IN_PROCESS"] = "IN_PROCESS";
    ELobMailedStatementStatuses["IN_TRANSIT"] = "IN_TRANSIT";
    ELobMailedStatementStatuses["REROUTED"] = "REROUTED";
    ELobMailedStatementStatuses["PROCESSED_FOR_DELIVERY"] = "PROCESSED_FOR_DELIVERY";
    ELobMailedStatementStatuses["IN_LOCALAREA"] = "IN_LOCALAREA";
    ELobMailedStatementStatuses["DELIVERED"] = "DELIVERED";
    ELobMailedStatementStatuses["PENDING"] = "PENDING";
})(ELobMailedStatementStatuses = exports.ELobMailedStatementStatuses || (exports.ELobMailedStatementStatuses = {}));
;
var EStatmentDownloadOption;
(function (EStatmentDownloadOption) {
    EStatmentDownloadOption["MAILED"] = "MAILED";
    EStatmentDownloadOption["NOT_MAILED"] = "NOT_MAILED";
    EStatmentDownloadOption["ALL"] = "ALL";
})(EStatmentDownloadOption = exports.EStatmentDownloadOption || (exports.EStatmentDownloadOption = {}));
// These statuses are used in recalculate_batch() trigger function on zunta-management-service
// Please, update trigger function logic, if you update the statuses
var ELetterStatus;
(function (ELetterStatus) {
    ELetterStatus["SKIP"] = "SKIP";
    ELetterStatus["READY_TO_MAIL"] = "READY_TO_MAIL";
    ELetterStatus["NEEDS_FIX"] = "NEEDS_FIX";
    ELetterStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ELetterStatus["DELIVERED"] = "DELIVERED";
    ELetterStatus["PROCESSED_FOR_DELIVERY"] = "PROCESSED_FOR_DELIVERY";
    ELetterStatus["REROUTED"] = "REROUTED";
    ELetterStatus["PENDING"] = "PENDING";
    ELetterStatus["PRINTED_LOCALLY"] = "PRINTED_LOCALLY";
    ELetterStatus["IN_PROCESS"] = "IN_PROCESS";
    ELetterStatus["IN_TRANSIT"] = "IN_TRANSIT";
    ELetterStatus["IN_LOCALAREA"] = "IN_LOCALAREA";
    ELetterStatus["EMAILED"] = "EMAILED";
    ELetterStatus["RETURNED"] = "RETURNED";
    ELetterStatus["EMAIL_RETURNED"] = "EMAIL_RETURNED";
    ELetterStatus["DO_NOT_BILL"] = "DO_NOT_BILL";
    ELetterStatus["DO_NOT_BILL_RETURNED"] = "DO_NOT_BILL_RETURNED";
    ELetterStatus["DO_NOT_BILL_EMAIL_RETURNED"] = "DO_NOT_BILL_EMAIL_RETURNED";
})(ELetterStatus = exports.ELetterStatus || (exports.ELetterStatus = {}));
var ELobMailedLetterStatuses;
(function (ELobMailedLetterStatuses) {
    ELobMailedLetterStatuses["IN_PROCESS"] = "IN_PROCESS";
    ELobMailedLetterStatuses["IN_TRANSIT"] = "IN_TRANSIT";
    ELobMailedLetterStatuses["REROUTED"] = "REROUTED";
    ELobMailedLetterStatuses["PROCESSED_FOR_DELIVERY"] = "PROCESSED_FOR_DELIVERY";
    ELobMailedLetterStatuses["IN_LOCALAREA"] = "IN_LOCALAREA";
    ELobMailedLetterStatuses["DELIVERED"] = "DELIVERED";
    ELobMailedLetterStatuses["PENDING"] = "PENDING";
})(ELobMailedLetterStatuses = exports.ELobMailedLetterStatuses || (exports.ELobMailedLetterStatuses = {}));
;
var EBatchType;
(function (EBatchType) {
    EBatchType["STATEMENTS"] = "STATEMENTS";
    EBatchType["LETTERS"] = "LETTERS";
    EBatchType["RETURNED_MAILS"] = "RETURNED_MAILS";
    EBatchType["COLLECTION_MAIL"] = "COLLECTION_MAIL";
})(EBatchType = exports.EBatchType || (exports.EBatchType = {}));
var EBatchProcessType;
(function (EBatchProcessType) {
    EBatchProcessType["GENERATE"] = "GENERATE";
    EBatchProcessType["UPDATE"] = "UPDATE";
    EBatchProcessType["AUTO_UPDATE"] = "AUTO_UPDATE";
})(EBatchProcessType = exports.EBatchProcessType || (exports.EBatchProcessType = {}));
;
var EBatchProcessStatus;
(function (EBatchProcessStatus) {
    EBatchProcessStatus["PENDING"] = "PENDING";
    EBatchProcessStatus["COMPLETE"] = "COMPLETE";
    EBatchProcessStatus["ERROR"] = "ERROR";
})(EBatchProcessStatus = exports.EBatchProcessStatus || (exports.EBatchProcessStatus = {}));
;
var EBatchGenerationSource;
(function (EBatchGenerationSource) {
    EBatchGenerationSource["NCS"] = "NCS";
    EBatchGenerationSource["PCC"] = "PCC";
    EBatchGenerationSource["PCC_NEW_LOGIN"] = "PCC_NEW_LOGIN";
})(EBatchGenerationSource = exports.EBatchGenerationSource || (exports.EBatchGenerationSource = {}));
;
